import React from 'react';

interface MainContentProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  isSidebarOpen?: boolean;
  onSidebarToggle?: () => void;
}

export const MainContent: React.FC<MainContentProps> = ({ 
  title, 
  children, 
  className = '',
  isSidebarOpen,
  onSidebarToggle
}) => {
  // Clone children and pass sidebar props if children is a valid React element
  const enhancedChildren = React.isValidElement(children)
    ? React.cloneElement(children as React.ReactElement<any>, { isSidebarOpen, onSidebarToggle })
    : children;

  return (
    <main className={`bg-[var(--color-l-bg-1)] dark:bg-[var(--color-d-bg-1)] ${className}`}>
      <div className="max-w-4xl mx-auto px-6 py-8">
        {title && (
          <div className="mb-8 border-b border-[var(--color-border-l)] dark:border-[var(--color-border-d)] pb-4">
            <h1 className="text-3xl font-bold text-[var(--color-l-text-1)] dark:text-[var(--color-d-text-1)] mb-2">
              {title}
            </h1>
            <p className="text-[var(--color-l-text-2)] dark:text-[var(--color-d-text-2)] text-lg">
              API documentation and reference guide
            </p>
          </div>
        )}
        <div className="prose prose-lg max-w-none text-[var(--color-l-text-1)] dark:text-[var(--color-d-text-1)]">
          {enhancedChildren}
        </div>
        

      </div>
    </main>
  );
};
